export enum EventEntity {
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_FIELD = 'CUSTOMER_FIELD',
  EVENT = 'EVENT',
  EVENTS = 'EVENTS',
  SERVICE = 'SERVICE',
  SERVICE_GROUP = 'SERVICE_GROUP',
  RESOURCE = 'RESOURCE',
  TIME_SHIFT = 'TIME_SHIFT',
  SUBSCRIPTION = 'SUBSCRIPTION',
  NOTIFICATION = 'NOTIFICATION',
  BEFORE_CONFIRMATIONS = 'BEFORE_CONFIRMATIONS',
  BEFORE_REMINDERS = 'BEFORE_REMINDERS',
  COMPANY = 'COMPANY',
  MANAGER = 'MANAGER',
  ENTERPRISE = 'ENTERPRISE',
  TAG = 'TAG',
}

export enum EventType {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
  SYNC = 'SYNC',
}

export interface EventPayload {
  name: EventEntity;
  types: EventType[];
}

export const eventsOptions = [
  {
    value: EventEntity.CUSTOMER,
    label: 'webhook.event.customers',
  },
  {
    value: EventEntity.CUSTOMER_FIELD,
    label: 'webhook.event.customerField',
  },
  {
    value: EventEntity.EVENT,
    label: 'webhook.event.event',
  },
  {
    value: EventEntity.EVENTS,
    label: 'webhook.event.events',
  },
  {
    value: EventEntity.SERVICE,
    label: 'webhook.event.service',
  },
  {
    value: EventEntity.SERVICE_GROUP,
    label: 'webhook.event.serviceGroup',
  },
  {
    value: EventEntity.RESOURCE,
    label: 'webhook.event.resource',
  },
  {
    value: EventEntity.TIME_SHIFT,
    label: 'webhook.event.timeShift',
  },
  {
    value: EventEntity.SUBSCRIPTION,
    label: 'webhook.event.subscription',
  },
  {
    value: EventEntity.NOTIFICATION,
    label: 'webhook.event.notification',
  },
  {
    value: EventEntity.BEFORE_CONFIRMATIONS,
    label: 'webhook.event.beforeConfirmations',
  },
  {
    value: EventEntity.BEFORE_REMINDERS,
    label: 'webhook.event.beforeReminders',
  },
  {
    value: EventEntity.COMPANY,
    label: 'webhook.event.company',
  },
  {
    value: EventEntity.MANAGER,
    label: 'webhook.event.manager',
  },
  {
    value: EventEntity.ENTERPRISE,
    label: 'webhook.event.enterprise',
  },
  {
    value: EventEntity.TAG,
    label: 'webhook.event.tag',
  },
];

export type EventTypes = 'CREATED' | 'UPDATED' | 'DELETED' | 'SYNC';

export interface ISelectFieldsConfig<T = any> {
  [key: string]: T[];
}

export const eventsConfig: ISelectFieldsConfig<EventTypes> = {
  [EventEntity.CUSTOMER]: ['CREATED', 'UPDATED', 'DELETED'],
  [EventEntity.CUSTOMER_FIELD]: ['CREATED', 'UPDATED', 'DELETED'],
  [EventEntity.EVENT]: ['CREATED', 'UPDATED', 'DELETED'],
  [EventEntity.EVENTS]: ['DELETED'],
  [EventEntity.SERVICE]: ['CREATED', 'UPDATED', 'DELETED'],
  [EventEntity.SERVICE_GROUP]: ['CREATED', 'UPDATED', 'DELETED'],
  [EventEntity.RESOURCE]: ['CREATED', 'UPDATED', 'DELETED'],
  [EventEntity.TIME_SHIFT]: ['CREATED', 'UPDATED', 'DELETED'],
  [EventEntity.NOTIFICATION]: ['CREATED'],
  [EventEntity.BEFORE_CONFIRMATIONS]: ['SYNC'],
  [EventEntity.BEFORE_REMINDERS]: ['SYNC'],
  [EventEntity.SUBSCRIPTION]: ['CREATED', 'UPDATED', 'DELETED'],
  [EventEntity.COMPANY]: ['CREATED', 'UPDATED', 'DELETED'],
  [EventEntity.MANAGER]: ['CREATED', 'UPDATED', 'DELETED'],
  [EventEntity.ENTERPRISE]: ['UPDATED'],
  [EventEntity.TAG]: ['CREATED', 'UPDATED', 'DELETED'],
};
